// cr media 標題

import Image from "next/image";
import { MEDIA_CONTENT } from "../common/constant";

const CRMediaTitle = () =>{
    return(
        <div className="title-wrap relative w-[fit-content] whitespace-nowrap flex items-center justify-center usm:m-auto">
            <p className="text-russo text-black text-[65px] leading-none font-[300] usm:text-[32px]">{MEDIA_CONTENT?.[0]}</p>
            &emsp;
            <p className="text-russo text-red0 text-[65px] leading-none font-[300] usm:text-[32px]">{MEDIA_CONTENT?.[1]}</p>

            <div className="absolute right-[-38px] bottom-[15px] w-[134px] h-full usm:hidden">
                <Image
                    alt="line-image"
                    width={134}
                    height={62}
                    src={"/images/cryptoread/section4/line.svg"}
                    className="absolute "
                />
            </div>
        </div>
    )
}

export default CRMediaTitle;